import { Button, Tooltip } from "@izicvs/ui";
import { cn } from "@izicvs/utils";
import { t } from "@lingui/macro";
import { ArrowLeft, Lock, NotePencil, Palette } from "@phosphor-icons/react";
import { Link } from "react-router";

import { useBuilderStore } from "@/client/stores/builder";
import { useResumeStore } from "@/client/stores/resume";

export const BuilderHeader = () => {
  const title = useResumeStore((state) => state.resume.title);
  const locked = useResumeStore((state) => state.resume.locked);

  const toggle = useBuilderStore((state) => state.toggle);
  const isDragging = useBuilderStore(
    (state) => state.panel.left.handle.isDragging || state.panel.right.handle.isDragging,
  );
  const leftPanelSize = useBuilderStore((state) => state.panel.left.size);
  const rightPanelSize = useBuilderStore((state) => state.panel.right.size);

  return (
    <div
      style={{ left: `${leftPanelSize}%`, right: `${rightPanelSize}%` }}
      className={cn(
        "fixed inset-x-0 top-0 z-[60] h-16 bg-secondary-accent/50 backdrop-blur-lg lg:z-20",
        !isDragging && "transition-[left,right]",
      )}
    >
      <div className="flex h-full items-center justify-between gap-2 px-3">
        {/* Back to the resume library */}
        <Button asChild variant="ghost" size="sm" className="shrink-0 gap-1.5">
          <Link to="/dashboard/resumes">
            <ArrowLeft className="size-4" />
            <span className="hidden text-sm sm:inline">{t`My resumes`}</span>
          </Link>
        </Button>

        {/* Resume title */}
        <div className="flex min-w-0 flex-1 items-center justify-center gap-1.5">
          <h1 className="truncate font-medium">{title}</h1>
          {locked && (
            <Tooltip content={t`This resume is locked, please unlock to make further changes.`}>
              <Lock size={14} className="shrink-0 opacity-75" />
            </Tooltip>
          )}
        </div>

        {/* Panel toggles (mobile / narrow only): labelled Content and Design */}
        <div className="flex shrink-0 items-center gap-1 lg:hidden">
          <Button
            size="sm"
            variant="ghost"
            className="gap-1.5 px-2.5"
            onClick={() => {
              toggle("left");
            }}
          >
            <NotePencil className="size-4" />
            <span className="text-sm">{t`Content`}</span>
          </Button>
          <Button
            size="sm"
            variant="ghost"
            className="gap-1.5 px-2.5"
            onClick={() => {
              toggle("right");
            }}
          >
            <Palette className="size-4" />
            <span className="text-sm">{t`Design`}</span>
          </Button>
        </div>
      </div>
    </div>
  );
};
